/*!

=========================================================
* Now UI Kit PRO React - v1.4.0
=========================================================

* Product Page: https://www.creative-tim.com/product/now-ui-kit-pro-react
* Copyright 2020 Creative Tim (http://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// styles
import "assets/css/bootstrap.min.css";
import "assets/scss/now-ui-kit.scss?v=1.4.0";
import "assets/demo/demo.css?v=1.4.0";
import "assets/demo/react-demo.css?v=1.4.0";
import "assets/demo/nucleo-icons-page-styles.css?v=1.4.0";
// pages
import AboutUs from "views/examples/AboutUs.js";
import BlogPost from "views/examples/BlogPost.js";
import BlogPosts from "views/examples/BlogPosts.js";
import ContactUs from "views/Contactus.js";
import Ecommerce from "views/examples/Ecommerce.js";
import Index from "views/Index.js";
import LandingPage from "views/examples/LandingPage.js";
import LoginPage from "views/examples/LoginPage.js";
import NucleoIcons from "views/NucleoIcons.js";
import Presentation from "views/Presentation.js";
import PracticeCalendar from "views/PracticeCalendar";
import TourneyCalendar from "views/TourneyCalendar";
import DropinCalendar from "views/DropinCalendar";
import Philosphy from "views/Philosphy.js";
import Facilities from "views/Facilities.js";
import Pricing from "views/Pricing.js";
import Management from "views/Management.js";
import Coaches from "views/Coaches.js";
import Announcements from "views/Announcements.js";
import CohortGallery from "views/CohortGallery.js";
import TourneyGallery from "views/TourneyGallery.js";
import GeneralGallery from "views/GeneralGallery.js";
import ActiveEvents from "views/ActiveEvents.js";
import Blogs from "views/Blogs.js";
import Projects from "views/Projects.js";
import Store from "views/Store.js";
import Contactus from "views/Contactus.js";
import Underconstruction from "views/Underconstruction.js";


import ProductPage from "views/examples/ProductPage.js";
import ProfilePage from "views/examples/ProfilePage.js";
import Sections from "views/Sections.js";
import SignupPage from "views/examples/SignupPage.js";
// others

const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      {/*
      <Route path="/about-us" render={(props) => <AboutUs {...props} />} />
      <Route path="/blog-post" render={(props) => <BlogPost {...props} />} />
      <Route path="/blog-posts" render={(props) => <BlogPosts {...props} />} />
      <Route path="/contact-us" render={(props) => <ContactUs {...props} />} />
      <Route path="/e-commerce" render={(props) => <Ecommerce {...props} />} />
      */}
      <Route path="/index" element={<Presentation />} />
      <Route path="/practicecalendar" element={<PracticeCalendar />} />
      <Route path="/tourneycalendar" element={<TourneyCalendar />} />
      <Route path="/dropincalendar" element={<DropinCalendar />} />
      <Route path="/philosphy" element={<Philosphy />} />
      <Route path="/facilities" element={<Facilities />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/management" element={<Management />} />
      <Route path="/coaches" element={<Coaches />} />
      <Route path="/announcements" element={<Announcements />} />
      <Route path="/blogs" element={<Underconstruction />} />
      <Route path="/projects" element={<Underconstruction />} />
      <Route path="/cohortgallery" element={<CohortGallery />} />
      <Route path="/tourneygallery" element={<TourneyGallery />} />
      <Route path="/generalgallery" element={<GeneralGallery />} />
      <Route path="/store" element={<Underconstruction />} />
      <Route path="/activeevents" element={<ActiveEvents />} />
      <Route path="/contactus" element={<ContactUs />} />

      {/*
      <Route
        path="/landing-page"
        render={(props) => <LandingPage {...props} />}
      />
      <Route path="/login-page" render={(props) => <LoginPage {...props} />} />
      <Route
        path="/nucleo-icons"
        render={(props) => <NucleoIcons {...props} />}
      />
      */}
      <Route path="/presentation" element={<Presentation />} />
      {/*
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/product-page" element={<ProductPage />} />
      <Route path="/profile-page" element={<ProfilePage />} />
      <Route path="/sections" element={<Sections />} />
      <Route path="/sign-up" element={<SignupPage />} />
      */}
      <Route path="*" element={<Navigate to="/presentation" replace />} />
    </Routes>
  </BrowserRouter>
);
